import BaseHttp from "@/api/httpHelper";
import apiGwClient from "@/api/api.gateway";
import type { IAddTenant, IPropertyCreate } from "@/types/requests";
import type {
  IPropertyDetailResponse,
  IPropertyResponse,
} from "@/types/response";

class PropertyService extends BaseHttp {
  async getProperties(
    pageNumber: number,
    pageSize: number,
    searchTerm: string
  ) {
    const { data } = await this.get<IPropertyResponse>(
      "",
      { pageNumber, pageSize, searchTerm },
      { requestKey: "getProperties" }
    );
    return data;
  }
  async getPropertyById(id: string) {
    const { data } = await this.get<IPropertyDetailResponse>(
      `/${id}`,
      {},
      { requestKey: "getPropertyById" }
    );
    return data;
  }
  async createProperty(body: IPropertyCreate) {
    const { success, error } = await this.post<string>("", body, {
      requestKey: "createProperty",
    });
    return { success, error };
  }
  async deleteProperty(id: string) {
    const { success, error } = await this.delete<string>(
      `/${id}`,
      {},
      { requestKey: "deleteProperty" }
    );
    return { success, error };
  }
  async removeTenant(id: string, tenantId: string, exitDate: string) {
    const { success, error } = await this.delete<string>(
      `/${id}/tenant/${tenantId}?exitDate=${exitDate}`,
      {},
      { requestKey: "removeTenant" }
    );
    return { success, error };
  }
  async addTenant(id: string, body: IAddTenant) {
    const { data, success, error } = await this.post<string>(
      `/${id}/tenant`,
      body,
      {
        requestKey: "addTenant",
      }
    );
    return { data, success, error };
  }
}

export default new PropertyService(apiGwClient, "/api/v1/properties");
